module.exports = __webpack_public_path__ + "media/images/shop_wizard_complete_icon-11b923cc29f6427412d98f1df37eee9e.svg";